import i18n from '../i18n';
import { ChannelModel } from '@descomplica/dex-models';
import { TranslateResult } from 'vue-i18n';
import { UNDERGRADUATE_CATEGORY_SLUG } from '@/helpers/category';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { TrackMenuClicked } from '@/helpers/analytics/types';
import Sort from '@/helpers/sort';

interface SubMenuOption {
  label: string;
  routerPath?: string;
  src?: string;
  target?: string;
  onClickHandler?: Function;
}

export interface MenuOption {
  icon: string;
  label: TranslateResult;
  routerName?: string;
  options: SubMenuOption[];
  active?: boolean;
  src?: string;
  target?: string;
  onClickHandler?: Function;
  tag?: string;
  hideMobile?: boolean;
  hideDesktop?: boolean;
}

export class CategoryService {
  static menuOptions(
    getters: any,
    refs: { [key: string]: Vue | Element | Vue[] | Element[] },
    isCurrentRoute: Function,
    showSocialMetaverse: boolean,
  ): MenuOption[] {
    const channels = getters.allChannels;
    const { currentUndergradCourse } = getters;

    const defaultHomeOption = {
      icon: 'home',
      label: i18n.t('home'),
      routerName: 'home',
      options: [],
      active: isCurrentRoute('home'),
    };

    const menuOptions: MenuOption[] = [
      defaultHomeOption,
      {
        icon: 'disciplines',
        label: i18n.t('subjects'),
        routerName: 'classrooms',
        options: [],
        active: isCurrentRoute('classrooms'),
      },
    ];

    if (currentUndergradCourse) {
      const forumOptions: SubMenuOption[] = channels
        .sort(Sort.byName)
        .map((channel: ChannelModel) => ({
          label: channel.name,
          routerPath: `/${UNDERGRADUATE_CATEGORY_SLUG}/${currentUndergradCourse.slug}/forum/canal/${channel.id}`,
        }));

      menuOptions.push({
        icon: 'forum',
        label: i18n.t('forum'),
        routerName: window.innerWidth > 640 ? '' : 'forum',
        options: forumOptions,
        active: isCurrentRoute('forum'),
      });

      menuOptions.push({
        icon: 'collectionsBookmark',
        label: i18n.t('library'),
        routerName: window.innerWidth > 640 ? '' : 'library',
        options: [
          {
            label: 'Acervo Digital Pearson',
            onClickHandler: () => {
              (refs.pearsonSubmit as HTMLBaseElement).click();
            },
          },
        ],
        active: isCurrentRoute('library'),
      });
    }

    menuOptions.push({
      icon: 'annotation',
      label: i18n.t('annotations'),
      routerName: 'notebooks',
      options: [],
      active: isCurrentRoute('notebooks'),
    });

    if (currentUndergradCourse) {
      menuOptions.push({
        icon: 'work',
        label: i18n.t('career'),
        options: [],
        src: `https://descomplica-csm.symplicity.com/students/index.php`,
        target: '_blank',
        onClickHandler: () =>
          Analytics.trackEvent(EVENT_LABELS.menuClicked, {
            interaction_type: 'Careers Clicked',
          } as TrackMenuClicked),
      });
    }

    if (showSocialMetaverse) {
      menuOptions.push({
        icon: 'friends',
        label: 'DesCoverse',
        routerName: 'desconverse',
        options: [],
        tag: 'NOVO',
        active: isCurrentRoute('desconverse'),
        hideMobile: true,
      });
    }

    return menuOptions;
  }
}
